module.exports = __webpack_public_path__ + "img/icon_map_1_on_010.29d2ff93.png";